<template>
  <div :style="style" :class="{ 'margin-auto': marginAuto }"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "18px",
    },
    iconColor: {
      type: String,
      default: "#1E2837",
    },
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
    },
    marginAuto: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    setPathIcon: function () {
      return require(`@/../public/icons/${this.icon}.svg`);
    },
    style() {
      const color = this.getColor(this.color || this.iconColor);

      let ret = "";

      if (this.icon) {
        ret += `mask: url(${this.setPathIcon}) no-repeat center / contain; 
              -webkit-mask: url(${this.setPathIcon}) no-repeat center / contain;`;
      }

      if (color) {
        ret += `background-color: ${color};`;
      }
      if (this.size) {
        ret += `width: ${this.size};
                    height: ${this.size};`;
      }
      return ret;
    },
  },
  methods: {
    getColor(value = "") {
      if (!value) return "";
      if (value.startsWith("#")) return value;

      // TODO: Find a way to differentiate between light and dark theme
      const color = this.$vuetify.theme.themes.light[value] || "";
      return color;
    },
  },
};
</script>

<style scoped>
.margin-auto {
  margin: 0 auto;
}
</style>
